{
    "releaseNotes": {
        "tabName": "Cronologia delle versioni",
        "accordianHeading": "Rilascia me@eon V<version>",
        "accordianMyHelpHeading": "Rilascia MyHelp (me@eon) V<version>",
        "accordianMyHelpNewHeading": "Rilascia MyHelp V<version>",
        "whatsNew": "Novità",
        "tipsAndTricks": "Suggerimenti e trucchi",
        "faq": "FAQ"
    },
    "ourTeam": {
        "tabName": "Il nostro team",
        "keyMembers": "Membri chiave"
    },
    "featureRoadmap": {
        "tabName": "Caratteristiche e Roadmap"
    }
}